import type { ReactNode } from "react";
import { Card, CardContent } from "./ui/card";

/**
 * Jadval ustidagi kichik ko'rsatkich kartasi.
 *
 * Analitika sahifasidagi `KpiCard`dan farqi — sparkline va o'zgarish nishoni
 * yo'q: bu kartalar joriy holatni (ostatka qiymati, xodimlar soni) ko'rsatadi,
 * o'tgan davr bilan taqqoslash uchun asos yo'q. Uslub `border-dashed` bilan
 * ataylab "ikkilamchi" — sahifaning asosiy mazmuni baribir jadval.
 */
export function MiniKpi({
  label,
  value,
  hint,
}: {
  label: string;
  value: string;
  /** Yorliq yonidagi izoh tugmasi (masalan `InfoTooltip`). */
  hint?: ReactNode;
}) {
  return (
    <Card className="mini-kpi border-dashed">
      <CardContent className="p-4">
        <div className="flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">
          <span className="truncate">{label}</span>
          {hint}
        </div>
        <div className="font-num text-2xl font-bold tracking-tight tabular-nums mt-1">
          {value}
        </div>
      </CardContent>
    </Card>
  );
}
